import React from 'react';
import circle from '../../images/circle-shape.png';
import author from '../../images/author-03.jpg';
import shape6 from '../../images/shape-6.png';
import shape24 from '../../images/shape-24.png';
import shape23 from '../../images/shape-23.png';
import shape14 from '../../images/shape-14.png';
import logo from '../../images/logo.png'
import shape5 from '../../images/shape-5.png';
import shape8 from '../../images/shape-8.png';
import { useEffect, useState  } from "react";
import {Link,useNavigate,useParams} from 'react-router-dom';
import axios from "axios";
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { useRef } from 'react';
import overlaycomp from '../../Components/overlaycomp';
import { Player, ControlBar, ForwardControl, ReplayControl,BigPlayButton  ,PlaybackRateMenuButton } from 'video-react';
import 'video-react/dist/video-react.css';


const ShowLessons = () => {
  const target = useRef(null);
  let { real_id } = useParams()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
    const [showLessons, setshowLessons] = useState([]);
    const [progress, setProgress] = useState(0);
    let { id } = useParams()
    const navigate= useNavigate()
    
    function Nav(s){
        navigate("/courseList/"+s)
    }
    async function getshowLessons() {
      let { data } = await axios.get(
        `https://maps-medics-be.onrender.com/show_lession/${real_id}`
      );
      setshowLessons(data);

      console.log(data);
    }
  
    
    // let currentIndex = 0;
    // console.log(lightContainer);
    useEffect(() => {
    
        getshowLessons();

      }, []);

      const playerRef = useRef(null);

      const handleSeekBackward = (seconds) => {
        const currentTime = playerRef.current.getState().player.currentTime;
        playerRef.current.seek(currentTime - seconds);
      };
    
      const handleSeekForward = (seconds) => {
        const currentTime = playerRef.current.getState().player.currentTime;
        playerRef.current.seek(currentTime + seconds);
      };
      const handleSpeedChange = (speed) => {
        playerRef.current.setPlaybackRate(speed);
      };
      
    return (
   <>
   {/* <Navbar/> */}
  

<div class="section section-padding" style={{paddingTop:'5%'}}>
                    <div class=" container" style={{display:'flex' ,justifyContent:'center'}}>
                        <div class=" row " style={{margin:'0'}}> 
                        <div className="container">
                          <div className="row">
                            <div className="col-md-12">
                            <div class="progress" style={{display:'flex', justifyContent:'center'}}>
  <div class="progress-bar" role="progressbar" style={{width: `${progress}%`}} aria-valuenow={`${progress}`} aria-valuemin="0" aria-valuemax="100">{progress}%</div>
</div>
                            </div>
                          </div>
       
                        </div>
           
                   
                        {/* <div class="progress">
  <div class="progress-bar" role="progressbar" style={{width: `${progress}%`}} aria-valuenow={`${progress}`} aria-valuemin="0" aria-valuemax="100"></div>
</div> */}

                        {showLessons.map((p, index) => (
                                           <div className="col-md-12 p-1" style={{ minHeight:'1px', display:'flex', justifyContent:'center'}}>

                   <div  value={p.id} key={index}>
        <h2 class="title"  style={{textDecoration:'none', cursor:'pointer' , color:'rgb(33, 37, 41)', fontSize:'21px', fontWeight:'700', fontFamily:'Poppins' }} onClick={()=>Nav(p.real_id)} >{p.name}</h2>
          
              <div >
              <div style={{ width: '900px', height: '520px', margin: 'auto', display: 'flex !important', justifyContent: 'center', alignItems: 'center' }}>
              <div style={{positon:"relative"}}>
                <div style={{width:"30%", height:"10%", position:"absolute", opacity:"0.5", color:"red", fontSize:"40px", display:"flex", justifyContent:"center", alignItems:"center"}}>{sessionStorage.getItem("user_id")} </div>
              <Player
    ref={playerRef}
    autoPlay={false}
    src={p.video}
    
    width='100%'
    height='100%'
    controlBarClassName='my-custom-class'
    playbackRate={0.5}
    onEnded={async()=>{
      if(p.read != true){
        const currentTime =
        playerRef.current.getState().player.currentTime;
        let response = await axios.post(
          "https://maps-medics-be.onrender.com/read_lesson/"+id+"/"+sessionStorage.getItem("user_id") ,
          { duration: currentTime }
        );
      }
    }}
  >
          <BigPlayButton position="center" />

    <ControlBar autoHide={false}  className="my-class" >
      <ReplayControl seconds={10} order={2} />
      <ForwardControl seconds={10} order={3} />
      <PlaybackRateMenuButton rates={[1.75, 1.50, 1.25,1, 0.75, 0.5]} />

    </ControlBar>
  </Player>
  </div>
 
</div>


              {/* <h3  style={{textDecoration:'none', cursor:'pointer' , color:'rgb(33, 37, 41)', fontSize:'21px', fontWeight:'700', fontFamily:'Poppins' }} >{p.name}</h3> */}
            <hr />  <p style={{textDecoration:'none', marginTop:'0.5rem', fontWeight:'400', fontSize:'14px',color:'rgb(32, 33, 34)', fontFamily:'Poppins'}}>{p.description}</p>
            <div className="row">
              <div className="col-md-12 p-2"><a href={p.pdf1} target='_blank'><i class="fa-regular fa-file-pdf fs-1" style={{color:'#ffc600'}}></i></a>
                </div>  <div className="col-md-12 p-2">
                <a href={p.pdf2} target='_blank'><i class="fa-regular fa-file-pdf fs-1" style={{color:'#ffc600'}}></i></a>
                </div>
                </div> 
            
              
              </div>
              
          
              </div>
                
                                
                                 
                </div>
                            
                         ))}
                     
                        
                        </div>
                    </div>
                </div>

        {/* <Footer/> */}
   </>
    );
}

export default ShowLessons;
